// main.tsx — T063
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './hooks/useAuth';
import { AppSettingsProvider } from './hooks/useAppSettings';
import { ToastProvider } from './components/ui/Toast';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <AppSettingsProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AppSettingsProvider>
    </AuthProvider>
  </React.StrictMode>,
);
